// @generated by tools/docgen — do not edit.
// Source: docs/examples/memo.md

import React from 'react';
import { MemoDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function MemoPage() {
  return (
    <ExampleLayout title="@memo" demo={<MemoDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This provides the exact same functionality as <a href={`${process.env.PUBLIC_URL || ''}/examples/carousel`} className="text-primary-700 hover:underline">rx field</a> example, now using @memo decorator. @memo receives a list of rx field names that are checked on any update to see if the value needs to be recalculated. Inspired by React's useMemo()
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-memo-backend">
        <ExampleSectionHeading id="examples-memo-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="memo/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-memo-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-memo-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="memo/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default MemoPage;
